






































import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import VesselsClient from "Clients/vessels-client";
import { Vessel } from "@/types/vessel";
import { Metric, VesselComparisonMode } from "@/types/vesselComparison";
import { ILongTrend } from "@/types/longTrend";
import store from "@/store";
import VesselComparisonModule from "@/store/clients/VesselComparison.module";
import VesselComparisonFilters from "./VesselComparisonFilters.vue";
import VesselComparisonEmptyState from "./VesselComparisonEmptyState.vue";
import VesselComparisonViewToggle from "./VesselComparisonViewToggle.vue";
import ComparisonCard from "./Comparisons/ComparisonCard.vue";

const VesselComparisonData = getModule(VesselComparisonModule, store);

@Component({
  components: {
    VesselComparisonFilters,
    VesselComparisonEmptyState,
    VesselComparisonViewToggle,
    ComparisonCard,
  },
})
export default class VesselComparison extends Vue {
  vessels: Vessel[] = [];
  metrics: Metric[] = [];
  vesselsList: Vessel[] = [];
  metricsList: Metric[] = [];
  comparisonSelected: boolean = false;
  mode: VesselComparisonMode = VesselComparisonMode.Chart;

  get vesselIds() {
    return this.vessels.map(vessel => vessel.id);
  }

  get trendNames() {
    return this.metrics.map(metric => metric.name);
  }

  get isComparisonLoading() {
    return VesselComparisonData.loading.periods;
  }

  get isTrendsLoading() {
    return VesselComparisonData.loading.trends;
  }

  get comparisons() {
    return VesselComparisonData.getPeriods({
      vesselIds: this.vesselIds,
      trendNames: this.trendNames,
    });
  }

  get themeClass(): string {
    return this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
  }
  
  async created() {
    this.vesselsList = await VesselsClient.getVessels(false);
    this.setPreselectedVessels();
  }

  @Watch("vessels")
  async onVesselChange() {
    await VesselComparisonData.ensureTrendsForVessels({ vesselIds: this.vesselIds });

    this.metricsList = VesselComparisonData.commonMetrics(this.vesselIds);
    const allowed = new Set(this.metricsList.map(m => m.name));
    this.metrics = this.metrics.filter(metric => allowed.has(metric.name));
  }

  @Watch("metrics")
  onMetricChange() {
    if (!this.comparisonSelected) return;
    this.fetchLastPeriods();
  }

  setPreselectedVessels() {
    const vesselIdsParam = this.$route.params.vesselIds;

    if (!vesselIdsParam) return;

    const vesselIds = vesselIdsParam.split(",").map(Number);
    this.vessels = this.vesselsList.filter(vessel => vesselIds.includes(vessel.id));
  }

  async onCompareClick() {
    await this.fetchLastPeriods();
    await this.fetchLastTrendEvents();
    this.comparisonSelected = true;
  }

  async fetchLastPeriods() {
    await VesselComparisonData.ensureLastPeriodsForSelection({
      vesselIds: this.vesselIds,
      trendNames: this.trendNames,
    });
  }

  async fetchLastTrendEvents() {
    await VesselComparisonData.ensureLastTrendEvent({ vesselIds: this.vesselIds });
  }

  intersectTrends(lists: ILongTrend[][]): ILongTrend[] {
    if (!lists.length) return [];

    const common = new Map<string, ILongTrend>(
      lists[0].map(t => [t.name, t])
    );

    for (let i = 1; i < lists.length && common.size; i++) {
      const names = new Set(lists[i].map(t => t.name));
      for (const name of common.keys()) {
        if (!names.has(name)) common.delete(name);
      }
    }

    return [...common.values()];
  }

  isMetricSelected(metric: string): boolean {
    return this.metrics.findIndex((m) => m.name === metric) > -1;
  }
}
